import { useNavigate, useLocation } from 'react-router-dom';
import { D, fmtAmt } from '@wave/shared';
import { useTransactions } from '../api/hooks';
import {
  pageContainer,
  pageHeader,
  pageSubtitle,
  pageTitle,
  tableCell,
  tableCellNum,
  tableCls,
  tableHead,
  tableHeadCell,
  tableHeadCellRight,
  tableRow,
  tableWrapper,
} from '../lib/styles';

export function TransactionsPage() {
  const { data, isLoading, error } = useTransactions(0, 200);
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className={pageContainer}>
      <div className={pageHeader}>
        <div>
          <h1 className={pageTitle}>Транзакции</h1>
          <p className={pageSubtitle}>
            Лог всех проводок и зеркальных записей по всем заявкам, в порядке убывания даты.
          </p>
        </div>
      </div>

      {isLoading && <div className="text-sm text-text2">Загрузка…</div>}
      {error && (
        <div className="rounded-md border border-[var(--red-border)] bg-[var(--red-bg)] px-3 py-2 text-sm text-danger">
          {(error as Error).message}
        </div>
      )}

      {data && (
        <>
          <div className="mb-3 text-xs font-medium text-text2">
            Всего записей: <span className="text-text">{data.total}</span>
          </div>
          <div className={tableWrapper}>
            <table className={tableCls}>
              <thead>
                <tr className={tableHead}>
                  <th className={tableHeadCell}>ID</th>
                  <th className={tableHeadCell}>Заявка</th>
                  <th className={tableHeadCell}>Тип</th>
                  <th className={tableHeadCell}>Счёт</th>
                  <th className={tableHeadCellRight}>Сумма</th>
                  <th className={tableHeadCell}>Статус</th>
                  <th className={tableHeadCell}>Дата</th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((tx) => {
                  const isNeg = D(tx.amount).isNegative();
                  return (
                    <tr key={tx.id} className={tableRow}>
                      <td className={`${tableCell} font-mono text-xs text-text2`}>{tx.id}</td>
                      <td className={tableCell}>
                        <button
                          className="font-mono text-sm font-semibold text-accent transition-colors duration-150 hover:text-accent2 hover:underline underline-offset-4"
                          onClick={() =>
                            navigate(`/orders/${tx.orderId}`, {
                              state: { backgroundLocation: location },
                            })
                          }
                        >
                          {tx.orderId}
                        </button>
                      </td>
                      <td className={tableCell}>
                        {tx.type === 'obligation' ? (
                          <span className="inline-flex items-center rounded border border-border bg-bg3 px-1.5 py-0.5 text-[11px] font-medium text-text2">
                            Обязат.
                          </span>
                        ) : (
                          <span className="inline-flex items-center rounded border border-[var(--accent-border)] bg-[var(--accent-bg)] px-1.5 py-0.5 text-[11px] font-medium text-accent">
                            ↩ Исполн.
                          </span>
                        )}
                      </td>
                      <td className={tableCell}>
                        <div className="text-[11px] text-text2">{tx.accountLabel}</div>
                        <div className="font-mono text-sm font-medium text-text">{tx.account}</div>
                      </td>
                      <td
                        className={`${tableCellNum} font-semibold ${isNeg ? 'text-danger' : 'text-success'}`}
                      >
                        {fmtAmt(tx.amount, tx.ccy)}
                      </td>
                      <td className={tableCell}>
                        {tx.status === 'done' ? (
                          <span className="inline-flex items-center gap-1 text-xs font-medium text-success">
                            ✓ Исполнена
                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-1 text-xs font-medium text-warning">
                            ⏳ Ожидание
                          </span>
                        )}
                      </td>
                      <td className={`${tableCell} font-mono text-xs text-text2`}>{tx.date}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
